import api from '@/apis/eTask/jobTitleAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('jobTitle', api);
const state = {
    ...crud.state,
    _config: {
        table: 'job_title',
        field: {
            key: 'JobTitleID',
            unique: 'JobTitleName',
            code: 'JobTitleName',
            name: 'JobTitleName',
        }
    }
};
const getters = {
    ...crud.getters
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations
};
export default {
    debug: process.env.NODE_ENV !== 'production',
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};